const CURRENCY_SYMBOLS = {
  AUD: 'A$',
  USD: '$',
  GBP: '£',
  CAD: 'CA$',
  EUR: '€',
  JPY: '¥',
};

export function currencySymbol(currency) {
  return CURRENCY_SYMBOLS[currency] || currency || '$';
}

export function formatPrice(amount, currency) {
  if (!amount && amount !== 0) return null;
  const sym = currencySymbol(currency);
  return `${sym}${parseFloat(amount).toFixed(2)}`;
}
